"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Category32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M5.009 20.763c-.566-.566-.636-1.485 0-2.121L16.039 7.61c.496-.495 1.344-.92 2.051-.92l7.213-.565c.92-.07 1.485.636 1.485 1.485l-.707 7.212a5.597 5.597 0 01-.849 1.98l-11.03 11.031c-.566.566-1.486.636-2.122 0l-7.071-7.071zm.707-.707l7.071 7.07c.212.213.495.213.707 0l11.031-11.03c.283-.283.566-.99.566-1.414l.565-7.213c0-.282-.141-.424-.424-.424l-7.212.566c-.425 0-1.132.283-1.415.565L5.575 19.207c-.071.354-.071.637.141.849zM21.202 11.5c-.425-.424-.425-.99 0-1.414.424-.425.99-.425 1.414 0 .424.424.424.99 0 1.414-.424.424-.99.424-1.414 0zm-10.96 5.303c-.213-.212-.213-.495 0-.707s.494-.212.707 0l5.727 5.728c.212.212.212.495 0 .707s-.495.212-.707 0l-5.727-5.728zM8.12 18.924c-.212-.212-.212-.494 0-.707.212-.212.495-.212.707 0l5.728 5.728c.212.212.212.495 0 .707s-.495.212-.707 0L8.12 18.924z" }))); };
var StyledCategory32 = styled_components_1.default(Category32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCategory32;
var templateObject_1;
//# sourceMappingURL=Category32.js.map